export default __webpack_public_path__ + "static/media/Buyers tab_closing.f1a06760.jpg";